import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import { acquireAccessToken } from '@/lib/auth/msal';
import { encodeURIObject } from '@/lib/utils/object';
import {
  FRONTEND_API_URL,
  REDIRECT_URL,
  AZURE_CLIENT_ID,
  AZURE_TENANT_ID,
  AZURE_API,
} from '@/lib/env';

async function getHeaders(accessToken: string) {
  const headers = new Headers({
    'Content-Type': 'application/json',
    authorization: `Bearer ${accessToken}`,
  });

  return headers;
}

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {} /* eslint-disable-line @typescript-eslint/no-empty-object-type */,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const accessToken = await acquireAccessToken(
    AZURE_CLIENT_ID,
    AZURE_TENANT_ID,
    REDIRECT_URL,
    AZURE_API
  );

  if (!accessToken) {
    throw new Error('Unauthorized');
  }
  return fetchBaseQuery({
    baseUrl: FRONTEND_API_URL,
    responseHandler: 'content-type',
    paramsSerializer: encodeURIObject,
    prepareHeaders: () => getHeaders(accessToken),
  })(args, api, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const frontendApi = createApi({
  reducerPath: 'frontendApi',
  // mock Next.js API
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
});
